import { FuelFlex } from '@frete.com/fuel-station-react';
import { useKebabMenu } from 'hooks/openSearchTrucker/useKebabMenu';
import { useTruckerSummary } from 'hooks/openSearchTrucker/useTruckerSummary';
import React, { FC } from 'react';
import Actions from './Actions';
import Body from './Body';
import Header from './Header';

const TruckerSummary: FC = () => {
  const { propsKebabMenu } = useKebabMenu();
  const {
    propsTruckerSummary: {
      openSearchWidth,
      openTruckerProfileButtonProps,
      riskManagement,
      searchedTrucker,
      copyButtonProps,
      hasAccount,
      hasChatButton,
    },
  } = useTruckerSummary();

  return (
    <FuelFlex defaultProps={{ flexDirection: 'column' }} testId="desktop-trucker-summary">
      <Header kebabProps={propsKebabMenu} {...searchedTrucker} />
      <Body searchedTrucker={searchedTrucker} hasAccount={hasAccount} copyButtonProps={copyButtonProps} />
      <Actions
        {...{ riskManagement, openSearchWidth, openTruckerProfileButtonProps, hasChatButton, searchedTrucker }}
      />
    </FuelFlex>
  );
};

export default TruckerSummary;
